import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'nominas/tabuladores-generales-percepciones';

/**
 * GET Tabuladores Generales Percepciones
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getTabuladoresGeneralesPercepciones = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Tabulador General Percepcion
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getTabuladorGeneralPercepcion = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Tabulador General
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postTabuladorGeneralPercepcion = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Tabulador General
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchATabuladorGeneralPercepcion = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Tabulador General
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteTabuladorGeneralPercepcion = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
